import { formatInTimeZone, getTimezoneOffset } from "date-fns-tz"
import { fetchQuery, graphql } from "relay-runtime"
import { initialTimeZoneQuery } from "@/lib/__generated__/initialTimeZoneQuery.graphql"
import { cacheOrDefault } from "@/lib/cache-helper"
import { DateOnly, DateOnlyFormat } from "@/lib/date-only"
import { RelayEnvironment } from "@/relay-environment"

export let defaultTimeZone = "Europe/Warsaw"
export let defaultTimeZoneOffset = getTimezoneOffset(defaultTimeZone)

export const formatInServerTimeZone = (date: string | Date, format: string = "yyyy-MM-dd HH:mm:ss") => {
  return formatInTimeZone(date, defaultTimeZone, format)
}

export const getServerDateOnly = (date?: Date) => {
  return new DateOnly(formatInServerTimeZone(date ?? new Date(), DateOnlyFormat))
}

export const fetchTimeZone = cacheOrDefault("timezone", async () => {
  const data = await fetchQuery<initialTimeZoneQuery>(
    RelayEnvironment,
    graphql`
      query initialTimeZoneQuery {
        timeZone
      }
    `,
    {},
  ).toPromise()

  if (data?.timeZone) {
    defaultTimeZone = data.timeZone
    defaultTimeZoneOffset = getTimezoneOffset(data.timeZone)
  }

  return data
})
